import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgMultivariantIcon } from "../shared/SvgMultivariantIcon";
import DocumentFillIcon from "./DocumentFillIcon";
import DocumentOutlineIcon from "./DocumentOutlineIcon";
var DocumentIcon = function DocumentIcon(props) {
  return /*#__PURE__*/React.createElement(SvgMultivariantIcon, _extends({}, props, {
    IconFill: DocumentFillIcon,
    IconOutline: DocumentOutlineIcon
  }));
};
export default DocumentIcon;